import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { catchError, forkJoin, map, Observable, of } from 'rxjs';

import { ReportsService } from '../../../core/services/reports.service';
import { LoadingService } from '../../../core/services/loading.service';

@Injectable({
  providedIn: 'root',
})
export class SchoolDashboardResolver {
  constructor(
    private reportsService: ReportsService,
    private loadingService: LoadingService,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    this.loadingService.start();

    return forkJoin({
      usageData: this.reportsService.getDistrictUsageData(),
      progressData: this.reportsService.getDistrictProgressData().pipe(
        catchError(() => of({ schools: {} }))
      ),
    }).pipe(
      map((data) => {
        this.loadingService.finish();
        return data;
      }),
      catchError((error) => {
        this.loadingService.finish();
        return of(error.status);
      })
    );
  }
}
